import { render, staticRenderFns } from "./Estatisticas.vue?vue&type=template&id=743830aa&scoped=true"
import script from "./Estatisticas.vue?vue&type=script&lang=js"
export * from "./Estatisticas.vue?vue&type=script&lang=js"
import style0 from "./Estatisticas.vue?vue&type=style&index=0&id=743830aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743830aa",
  null
  
)

export default component.exports